import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/B1YwEBQQrRdxuD6j6"
            >
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Samurai Sushi & Teriyaki Japanese"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/B1YwEBQQrRdxuD6j6"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="Samurai Sushi & Teriyaki Japanese"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
